// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__23ONg","clinicsSelect":"TableHeading_clinicsSelect__2MQXv"};